export default "__VITE_ASSET__BjTZxwj9__"